module.exports = __webpack_public_path__ + "img/ic_size.4d5a55f9.svg";